import { Controller } from '@lib/form'
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers'
import React from 'react'

type ControllerDatePickerProps = DatePickerProps & {
  control?: any
}

const ControllerDatePicker: React.FC<ControllerDatePickerProps> = React.forwardRef((props, ref) => {
  const { name, control, ...restProps } = props
  if (Boolean(control) && typeof name === 'string') {
    return (
      <Controller
        name={name}
        control={control}
        render={(args) => {
          return <DatePicker {...restProps} {...args.field} ref={ref} />
        }}
      />
    )
  }
  return <DatePicker name={name} {...restProps} ref={ref} />
})

ControllerDatePicker.displayName = 'ControllerDatePicker'

export default ControllerDatePicker
export * from '@mui/x-date-pickers/DatePicker'
